const labels = {
  es: {
    year: { one: 'año', other: 'años' },
    month: { one: 'mes', other: 'meses' },
    day: { one: 'día', other: 'días' },
    hour: { one: 'hora', other: 'horas' },
  },
  pt: {
    year: { one: 'ano', other: 'anos' },
    month: { one: 'mês', other: 'meses' },
    day: { one: 'dia', other: 'dias' },
    hour: { one: 'hora', other: 'horas' },
  },
  fr: {
    year: { one: 'an', other: 'ans' },
    month: { one: 'mois', other: 'mois' },
    day: { one: 'jour', other: 'jours' },
    hour: { one: 'heure', other: 'heures' },
  },
} as const;

export function getDurationLabel({
  durationInDays,
  durationInMonths,
  durationInYears,
}: {
  durationInDays?: number;
  durationInMonths?: number;
  durationInYears?: number;
}): string {
  const country = window.AR_APP_COUNTRY || '';

  if (durationInYears && durationInYears > 0) {
    return `${durationInYears} ${
      durationInYears === 1
        ? labels[country]?.year?.one
        : labels[country]?.year?.other
    }`;
  }

  if (durationInMonths && durationInMonths > 0) {
    return `${durationInMonths} ${
      durationInMonths === 1
        ? labels[country]?.month?.one
        : labels[country]?.month?.other
    }`;
  }

  return `${durationInDays} ${
    durationInDays === 1
      ? labels[country]?.day?.one
      : labels[country]?.day?.other
  }`;
}
